import { CKSelectableItem } from 'clearkit';

import { EnrichmentAttribute } from '~/generated/graphql';

import { FieldMapping, MappingProperty } from './types';
import { RecordType } from './useEnrichment/machineTypes';

export const lookupSelectableItem = (
  value: string,
  options: CKSelectableItem[],
) => {
  return options?.find((option) => option.value === value);
};

export const makeMappingProperty = (mapping: FieldMapping): MappingProperty => {
  return {
    clearbit: mapping.sourceField || '',
    hubspot: mapping.targetField || '',
  };
};

export const getFieldMetaData = (
  clearbitValue: string,
  clearbitAttributes: EnrichmentAttribute[],
) => {
  const attribute = clearbitAttributes?.find(
    (attribute) => attribute.value === clearbitValue,
  );

  return {
    sourceType: attribute?.meta.sourceType || '',
    dataType: attribute?.meta.dataType || '',
  };
};

export const getTransformedOptions = (
  recordType: RecordType,
  companyAttributes: EnrichmentAttribute[],
  personAttributes: EnrichmentAttribute[],
) => {
  return recordType === 'company'
    ? transformOptions(companyAttributes)
    : transformOptions(personAttributes);
};

export const transformOptions = (attributes: EnrichmentAttribute[]) => {
  const transformedOptions = attributes?.map((attribute) => {
    return {
      label: attribute.label,
      value: attribute.value,
    };
  });

  return transformedOptions;
};
